import { ChangeEventHandler, CSSProperties, RefObject } from "react";
import { RefCallBack } from "react-hook-form";
import classNames from "classnames";
import styles from "./Radio.module.css";
import Icon from "../Icon";

export interface IRadioProps {
  ariaLabel?: string;
  inputId?: string;
  name: string;
  value: string | number;
  checked?: boolean;
  text?: string;
  image?: string;
  description?: string;
  disabled?: boolean;
  onChange?: ChangeEventHandler<HTMLInputElement>;
  idForText?: number | string;
  style?: CSSProperties;
  innerStyle?: CSSProperties;
  inputRef?: RefObject<HTMLInputElement> | RefCallBack;
  inputDataCy?: string;
}

export const Radio = ({
  ariaLabel,
  inputId,
  name,
  value,
  checked,
  text,
  image,
  description = "",
  disabled = false,
  onChange,
  idForText,
  style,
  innerStyle,
  inputRef,
  inputDataCy,
}: IRadioProps) => (
  <div className={styles.radioContainer} style={{ ...innerStyle }}>
    {(() => {
      const id = (idForText ?? inputId) as string;
      const descriptionId = description ? `${id}-description` : undefined;

      return (
        <>
          <input
            data-cy={inputDataCy}
            ref={inputRef}
            type="radio"
            id={id}
            className={styles.radio}
            name={name}
            value={value}
            checked={checked}
            disabled={disabled}
            onChange={onChange}
            style={style}
            aria-describedby={descriptionId}
            aria-label={ariaLabel}
          />
          {image && (
            <span className={styles.radioIcon} aria-hidden="true">
              <Icon
                name={image}
                size={24}
                color={disabled ? "Grey-300" : "grey"}
              />
            </span>
          )}
          {text && (
            <label htmlFor={id} className={styles.radioText}>
              {text}
            </label>
          )}
          {description && (
            <span
              id={descriptionId}
              className={classNames("description", styles.radioDescription)}
            >
              {description}
            </span>
          )}
        </>
      );
    })()}
  </div>
);

export default Radio;
